import { render } from "./ProductContents.vue?vue&type=template&id=6b2a6eda&lang=pug"
import script from "./ProductContents.vue?vue&type=script&lang=js"
export * from "./ProductContents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__